
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Small Business Owner',
      content: 'The Insurance Doctors saved me thousands on my business insurance while actually improving my coverage. John\'s expertise made all the difference.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/c60540becd06aaf8839567cd69a64a06.jpg'
    },
    {
      name: 'Michael Rodriguez',
      role: 'Family Man',
      content: 'After my accident, I realized how important proper coverage is. Dr. Peterson diagnosed my gaps and got me the protection my family needed.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Hispanic%20middle-aged%20man%20with%20family%20photo%20background%2C%20warm%20smile%2C%20casual%20professional%20attire%2C%20trustworthy%20appearance%2C%20natural%20outdoor%20lighting&width=400&height=400&seq=testimonial-michael&orientation=squarish'
    },
    {
      name: 'Emily Chen',
      role: 'First-time Homeowner',
      content: 'As a first-time buyer, I was overwhelmed by insurance options. The team made it simple and found me great rates on bundled coverage.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20professional%20headshot%2C%20confident%20smile%2C%20modern%20business%20casual%20outfit%2C%20bright%20clean%20background%2C%20approachable%20friendly%20expression&width=400&height=400&seq=testimonial-emily&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in-up opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Patient Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See how our insurance treatments have helped protect families and businesses across the community.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all duration-500 hover:scale-105 animate-fade-in-up opacity-0 border border-white/20"
              style={{ animationDelay: `${(index + 1) * 200}ms` }}
            >
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4 shadow-lg"
                />
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">{testimonial.name}</h3>
                  <p className="text-blue-600 font-medium">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-600 leading-relaxed italic">
                "{testimonial.content}"
              </p>
              
              <div className="mt-6 flex items-center text-sm text-blue-600">
                <i className="ri-check-double-line mr-2"></i>
                Verified Patient
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 animate-fade-in-up opacity-0" style={{ animationDelay: '800ms' }}>
          <div className="bg-blue-600/95 backdrop-blur-sm rounded-2xl p-8 text-white border border-blue-400/20">
            <h3 className="text-3xl font-bold mb-4">Ready to Join Our Success Stories?</h3>
            <p className="text-xl mb-6 text-blue-100">
              Let us diagnose your insurance needs and prescribe the perfect protection plan.
            </p>
            <button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
              Get Your Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
